module.exports = __webpack_public_path__ + "images/11e6cb438042a78476d8d4f0ba23df27.png";